import React from 'react'
import { graphql } from 'gatsby'

// Components
import ReviewsPage from './ReviewsPage'

const ReviewsIndex = (props) => {
  // console.log('REVIEWS PAGE INDEX (template)', props)
  return <ReviewsPage {...props} />
}

export default ReviewsIndex

export const reviewsQuery = graphql`
  query ReviewsQuery {
    ...AllProductReviews
    ...SiteConfig
    prismicReviews {
      data {
        hero {
          title
          content
          image {
            alt
            gatsbyImageData(imgixParams: { auto: "format, compress" })
          }
        }
      }
    }
  }
`
